###
usergroup delete modal
###

# Libs
import _ from 'lodash'
import React from 'react'
import PropTypes from 'prop-types'
import cnames from 'classnames'
import adopt from 'libs/adopt'

# Renderable
import { div } from 'react-dom-factories'
Fragment = React.createFactory React.Fragment

import { NotificationConsumer } from '../../../application/components/NotificationManager'

import _BevyModal from '@bevy/modal'
BevyModal = React.createFactory _BevyModal

import { Icon as _Icon } from 'react-icons-kit'
Icon = React.createFactory _Icon

# Styles
import ErrorIcon from '@atlaskit/icon/glyph/error'

# Data
import {
	DeleteUserGroups
} from './data'

REFETCH_QUERIES = [
	'GroupsList'
	]

DataLayer = adopt
	mutations:
		deleteUserGroups: ({history, setNotification}) ->
			mutation: DeleteUserGroups
			refetchQueries: REFETCH_QUERIES
			onCompleted: (data) ->
				setNotification
					content: "User Group#{if (_.size data.userGroupsDelete) > 1 then 's' else ''} deleted"
					appearance: 'success'
				history.push "/groups"
			onError: (err) ->
				if err?.graphQLErrors? and (_.head err.graphQLErrors).message?
					setNotification ({content: (_.head err.graphQLErrors).message, appearance: 'error'})
				else
					setNotification ({content: 'Error deleting usergroup', appearance: 'error'})
export default class GroupDeleteModal extends React.Component
	@propTypes =
		onClose: PropTypes.func.isRequired

	constructor: (props) ->
		super props

	render: ->
		NotificationConsumer {}, ({setNotification}) =>
			DataLayer {
				history: @props.history
				setNotification: setNotification
				onConfirm: @props.onConfirm
			}, (operations) =>
				BevyModal {
					onClose: @props.onClose
					header: 'Delete confirmation'
					headerIcon: ErrorIcon {size: 'medium', primaryColor: '#DE350B'}
					actions: [
						text: 'Delete'
						onClick: () =>
							operations.deleteUserGroups.mutation
								variables:
									ids: @props.groupsIDs || [@props.groupID]
							@props.onClose()
					,
						text: 'Cancel'
						onClick: @props.onClose
					]
					note: 'Once deleted, it can be only restored by contacting your administrator.'
				},
					"Are you sure you want to delete this user group#{if (_.size @props.groupsIDs) > 1 then 's' else ''}?"

